import React, { useContext } from 'react';
import styles from '../../styles/Dashboard.module.css';
import { DashboardContext } from '../../store/dashboard-context';
import SelectBox from '../../components/UI/SelectBox';
import { PaginationContext } from '../../store/pagination-context';
import Spinner from '../../components/UI/Spinner';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DashboardFilters = () => {

    const dashboardCtx = useContext(DashboardContext);
    const paginationCtx = useContext(PaginationContext);

    // Function to calculate the date 90 days from today
    const getMinDate = () => {
        const today = new Date();
        const minDate = new Date(today.setDate(today.getDate() - 90));
        return minDate;
    };

    return (

        <div className={`${styles.filterContainer}`}>
            {dashboardCtx.isFilterLoading ?
                <div className="d-flex justify-content-center align-items-center" style={{ 'height': '35vh' }}>
                    <Spinner size="md" />
                </div>
                : (
                    <div className="container bodyContainer">
                        <div className={`${styles.filterContainerRow}`}>
                            <div className={`${styles.slecetContainer}`}>
                                <label className={`${styles.selectLabel}`}>Channel</label>
                                <SelectBox options={dashboardCtx.filters.channel} onSelect={dashboardCtx.handleSelect} name="channel" defaultSelected={dashboardCtx.selected_filter.channel} />
                            </div>
                            <div className={`${styles.slecetContainer}`}>
                                <label className={`${styles.selectLabel}`}>Scorecard</label>
                                <SelectBox options={dashboardCtx.filters.scorecards} onSelect={dashboardCtx.handleSelect} name="scorecard" defaultSelected={dashboardCtx.selected_filter.scorecard} />
                            </div>
                            <div className={`${styles.slecetContainer}`}>
                                <label className={`${styles.selectLabel}`}>Team Leader</label>
                                <SelectBox options={dashboardCtx.filters.managers} onSelect={dashboardCtx.handleSelect} name="manager" isMulti />
                            </div>
                            <div className={`${styles.slecetContainer}`}>
                                <label className={`${styles.selectLabel}`}>Team Member</label>
                                <SelectBox options={dashboardCtx.filters.team_members} onSelect={dashboardCtx.handleSelect} name="team_member" isMulti />
                            </div>
                        </div>
                        <div className={`${styles.filterContainerRow} mt-4`}>
                            <div className={`${styles.slecetContainer}`}>
                                <label className={`${styles.selectLabel}`}>Contact Reasons</label>
                                <SelectBox options={dashboardCtx.filters.contact_reasons} onSelect={dashboardCtx.handleSelect} name="contact_reason" isMulti />
                            </div>
                            <div className={`${styles.slecetContainer}`}>
                                <label className={`${styles.selectLabel}`}>Subcontact Reasons</label>
                                <SelectBox options={dashboardCtx.filters.sub_contact_reasons} onSelect={dashboardCtx.handleSelect} name="sub_contact_reason" isMulti />
                            </div>
                            <div className={`${styles.slecetContainer}`}>
                                <label className={`${styles.selectLabel}`}>Languages</label>
                                <SelectBox options={dashboardCtx.filters.languages} onSelect={dashboardCtx.handleSelect} name="language" isMulti />
                            </div>
                            <div className={`${styles.slecetContainer}`}>
                                <label className={`${styles.selectLabel}`}>Effort</label>
                                <SelectBox options={dashboardCtx.filters.customer_efforts} onSelect={dashboardCtx.handleSelect} name="customer_effort" isMulti />
                            </div>

                        </div>
                        <div className={`${styles.filterContainerRow} mt-4`}>
                            <div className={`${styles.slecetContainer}`}>
                                <label className={`${styles.selectLabel}`}>Date</label>
                                <SelectBox options={dashboardCtx.filters.report_periods} onSelect={dashboardCtx.handleSelect} name="report_period" defaultSelected={dashboardCtx.selected_filter.report_period} />
                            </div>
                            <div className={`${styles.slecetContainer}`}>
                                {dashboardCtx.selected_filter.report_period.key === 'custom' && (
                                    <>
                                        <label className={`${styles.selectLabel}`}>From</label>
                                        <DatePicker
                                            selected={dashboardCtx.selected_filter.custom_date_from}
                                            onChange={date => dashboardCtx.handleSelectDate('custom_date_from', String(date))}
                                            dateFormat="yyyy-MM-dd"
                                            className={`${styles.datepicker}`}
                                            minDate={getMinDate()}
                                            maxDate={new Date()}
                                        />
                                    </>
                                )}
                            </div>
                            <div className={`${styles.slecetContainer}`}>
                                {dashboardCtx.selected_filter.report_period.key === 'custom' && (
                                    <>
                                        <label className={`${styles.selectLabel}`}>To   </label>
                                        <DatePicker
                                            selected={dashboardCtx.selected_filter.custom_date_to}
                                            onChange={date => dashboardCtx.handleSelectDate('custom_date_to', String(date))}
                                            dateFormat="yyyy-MM-dd"
                                            className={`${styles.datepicker}`}
                                            minDate={dashboardCtx.selected_filter.custom_date_from || new Date()}
                                            maxDate={new Date()}
                                        />
                                    </>
                                )}
                            </div>
                            <div className={`${styles.btnContainer} mt-4`}>

                                {!dashboardCtx.isFilterApplied ? (
                                    <button
                                        type="button"
                                        className={`btn btn-primary ${styles.filterBtn}`}
                                        onClick={() => dashboardCtx.applyFilter(paginationCtx.queryString)}
                                    >
                                        Apply Filter
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className={`btn btn-default ${styles.filterBtn}`}
                                        onClick={() => dashboardCtx.clearFilter()}
                                    >
                                        Clear Filter
                                    </button>
                                )}

                            </div>
                        </div>

                    </div>
                )}

        </div>
    )
}

export default DashboardFilters
